import React, {Component} from 'react';
import {ChannelLogo} from "../../channels/ChannelLogo";
import {Button} from "reactstrap";
import {AddStoreModal} from "../../channels/shopify/AddStoreModal";
import {AddTiendaNubeStoreModal} from "../../channels/tienda_nube/AddTiendaNubeStoreModal";
import {AddKlaviyoAccountModal} from "../../channels/klaviyo/AddKlaviyoAccountModal";
import {AddWooCommerceStoreModal} from "../../channels/woocommerce/AddWooCommerceStoreModal";
import {AddVtexStoreModal} from "../../channels/vtex/AddVtexStoreModal";
import {Spinner} from "../../Spinner";
import {AdAccountDataRow} from "./AdAccountDataRow";
import { withTranslation } from 'react-i18next';
import {SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, KLAVIYO_CHANNEL, WOOCOMMERCE_CHANNEL, VTEX_CHANNEL} from "../../channels/channels";


class EcommerceConnectionsComponentClass extends Component {
    render() {
        const { t } = this.props;
        const wrapperClassName = `section-body-item -wider box${this.props.wrapperClassName ? ` ${this.props.wrapperClassName}` : ''}`;
        const title = this.props.titleOverride || (this.props.channel === KLAVIYO_CHANNEL ? t('ecommerce_connections_component.klaviyo_title') : t('ecommerce_connections_component.title'));
        return (
            <div className={wrapperClassName}>
                <header className="box-header">
                    <h2 className="box-title"><ChannelLogo channel={this.props.channel}/>{title}</h2>{this.renderLinkStoreButton()}
                </header>
                {this.getTableDataForLinkedStores()}
            </div>
        );
    }

    renderLinkStoreButton() {
        const { t } = this.props;
        const actionButtonClassName = this.props.actionButtonClassName || '-alt';
        const newConnectionLabel = this.props.newConnectionLabel || t('ecommerce_connections_component.new_connection');
        return <div className="float-right">
            <Button className={actionButtonClassName} onClick={(e) => {e.stopPropagation();this.addStoreModal.toggle()}}>{newConnectionLabel}</Button>
            {this.props.channel === SHOPIFY_CHANNEL && <AddStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={this.props.onAdAccountConnectionCreated}/>}
            {this.props.channel === TIENDA_NUBE_CHANNEL && <AddTiendaNubeStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={this.props.onAdAccountConnectionCreated}/>}
            {this.props.channel === KLAVIYO_CHANNEL && <AddKlaviyoAccountModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={this.props.onAdAccountConnectionCreated}/>}
            {this.props.channel === WOOCOMMERCE_CHANNEL && <AddWooCommerceStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={this.props.onAdAccountConnectionCreated}/>}
            {this.props.channel === VTEX_CHANNEL && <AddVtexStoreModal ref={instance => { this.addStoreModal = instance;}} afterSuccessfulSubmit={this.props.onAdAccountConnectionCreated}/>}
        </div>;
    }

    getTableDataForLinkedStores() {
        const { t } = this.props;
        if (this.props.adAccountConnections !== null) {
            const result = [<div className="table-box">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('ecommerce_connections_component.store')}</th>
                        {this.renderClientColumn()}
                        <th>{t('ecommerce_connections_component.url')}</th>
                        {this.renderAuthorizesColumn()}
                        <th>{t('ecommerce_connections_component.clients')}</th>
                        <th>{t('ecommerce_connections_component.accessible')}</th>
                        <th>{t('ecommerce_connections_component.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.adAccountConnectionsRows()}
                    </tbody>
                </table>
            </div>];

            return result;
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    renderClientColumn() {
        const { t } = this.props;
        if (this.showClientColumn()) {
            return (<th>{t('ecommerce_connections_component.client')}</th>);
        } else {
            return null;
        }
    }

    renderAuthorizesColumn() {
        const { t } = this.props;
        if (this.props.channel === TIENDA_NUBE_CHANNEL || this.props.channel === KLAVIYO_CHANNEL || this.props.channel === WOOCOMMERCE_CHANNEL || this.props.channel === VTEX_CHANNEL) {
            return null;
        }
        return <th>{t('ecommerce_connections_component.authorizes')}</th>;
    }

    showClientColumn() {
        return false;
    }

    adAccountConnectionsRows() {
        if(!this.props.adAccountsDatas)
            return;

        return this.props.adAccountsDatas.filter((adAccountData) => adAccountData.has_agency_ad_account_credential === true).map((adAccountData) =>
            <AdAccountDataRow key={adAccountData.ad_account_id}
                              adAccountData={adAccountData}
                              onRemove={this.props.doAdAccountRemove}
                              isSaving={this.props.isSaving}
            />
        );
    }
}

export const EcommerceConnectionsComponent = withTranslation()(EcommerceConnectionsComponentClass);
export default EcommerceConnectionsComponent;
